import { Button, List } from 'semantic-ui-react';
import { TEMPORARY_DESCRIPTOR_ID_PREFIX } from '../../../../constants/generalConstants';
import { ImportTableDescriptorType, RowMappingType } from '../../../../types';
import './styles.css';

type RemovedMappingsPropsType = {
    mappings: RowMappingType[];
    handleRestoreImportDescriptor: (mapping: RowMappingType) => void;
    importDescriptors: ImportTableDescriptorType[];
};
function RemovedMappings({ mappings, handleRestoreImportDescriptor, importDescriptors }: RemovedMappingsPropsType) {
    return (
        <List divided>
            {mappings.map((mapping) => {
                const importDescriptor = importDescriptors.find((d) => d.id === mapping.rowId);
                const hasMapping =
                    mapping.alternatives.filter((alt) => !alt.descriptorId.startsWith(TEMPORARY_DESCRIPTOR_ID_PREFIX))
                        .length > 0;
                return (
                    <List.Item key={mapping.rowId}>
                        <List.Content>
                            <List.Header className="removed-mapping">
                                {importDescriptor!.label}
                                {hasMapping && <List.Icon color="blue" name="map" />}
                                <Button
                                    onClick={() => handleRestoreImportDescriptor(mapping)}
                                    positive
                                    size="mini"
                                    icon="redo"
                                    className="ml-auto"
                                />
                            </List.Header>
                        </List.Content>
                    </List.Item>
                );
            })}
        </List>
    );
}

export default RemovedMappings;
